import { render, staticRenderFns } from "./BirthDateField.vue?vue&type=template&id=813a0f56&scoped=true"
import script from "./BirthDateField.vue?vue&type=script&lang=js"
export * from "./BirthDateField.vue?vue&type=script&lang=js"
import style0 from "./BirthDateField.vue?vue&type=style&index=0&id=813a0f56&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "813a0f56",
  null
  
)

export default component.exports